/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Mijn persoonsgegevens niet verkopen of delen",
      "Bumble Date",
      "Onze apps",
      "Over",
      "Vacatures",
      "Contact opnemen",
      "Investeerders",
      "De winkel",
      "Bedrijf",
      "Download de app",
      "Toegankelijkheid bij Bumble",
      "Richtlijnen",
      "Cookies beheren",
      "Verklaring inzake moderne slavernij",
      "Bericht over gegevensverzameling",
      "Privacybeleid",
      "Algemene voorwaarden",
      "Juridisch",
      "Privacybeleid gegevens consumentengezondheid Washington",
      "Scan de QR-code om de Bumble-app te downloaden",
      "Hier annuleren",
      "Menu sluiten",
      "Menu openen",
      "Talenselectie",
      "Voettekst",
      "Toegankelijkheid bij Bumble",
      "Apple en het Apple-logo zijn handelsmerken van Apple Inc.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Carrière",
      "Google Play is een handelsmerk van Google LLC.",
      "Richtlijnen",
      "Investeerders",
      "Cookies beheren",
      "Verklaring Modern Slavery Act",
      "Bericht over gegevensverzameling",
      "Privacybeleid",
      "Datinggidsen per seizoen",
      "Algemene voorwaarden",
      "De app",
      "Privacybeleid gegevens consumentengezondheid Washington",
      "Over",
      "Ambassadeurs",
      "Vind nieuwe vrienden en je eigen community",
      "Netwerk en zet carrièrestappen",
      "Zoek een relatie, iets dat niet bindend is of iets daartussenin",
      "Blog",
      "Lees hier meer",
      "Ga internationaal met Reismodus",
      "Date",
      "Functies",
      "Compliments",
      "Geef de ander wat Compliments en val op tussen de rest.",
      "Ontdekken",
      "Een persoonlijke pagina waarop je mensen vindt die goed bij je passen, dagelijks bijgewerkt.",
      "Privémodus",
      "Gebruik Privémodus om je profiel te verbergen van je baas, familie of ex(en).",
      "Instant match",
      "Een gesprek met iemand begonnen op een IRL-event van Bumble? Zet het voort in de app.",
      "Opening Moves",
      "Kies Opening Moves: nodig je match uit om de chat te beginnen.",
      "Snooze-modus",
      "Even pauze met Snooze-modus. Als je weer wilt daten, weet je ons te vinden.",
      "SuperSwipe",
      "Heeft een profiel de juiste vibe? Laat het weten met een SuperSwipe.",
      "Reismodus",
      "Vind je dutyfree snack en match overal ter wereld met Reismodus.",
      "Videochat",
      "Gebruik videochat en audiobellen en kijk of je er klaar voor bent om elkaar in het echt te ontmoeten.",
      "Web-app",
      "De Bumble-ervaring in je browser.",
      "Download de Bumble-app",
      "BFF",
      "Veiligheid",
      "Verhalen",
      "Support",
      "De winkel",
      "Hoofdmenu",
      "Geef de ander Compliments en val op tussen de rest.",
      "Compliments",
      "Functies om echte, respectvolle en betekenisvolle contacten aan te gaan.",
      "Verberg je profiel voor je baas, familie of exen.",
      "Privémodus",
      "Even pauze met Snooze-modus.",
      "Snooze-modus",
      "Iemand gezien die je leuk vindt? Laat het weten.",
      "SuperSwipe",
      "Date ontdekken",
      "Vind je dutyfree snack en match overal.",
      "Reismodus",
      "Zo is het bijna IRL, zonder dat je je huis uit hoeft.",
      "Videobellen",
      "Onze leiders integreren de waarden van Bumble in hun community's in het hele land.",
      "Leiders in de community",
      "Functies om mensen te vinden die bij je passen en te praten over wat je leuk vindt.",
      "Organiseer een bijeenkomst of ontdek lokale events in de buurt.",
      "Abonnementen",
      "BFF ontdekken",
      "Alle begeleiding en inspiratie die je nodig hebt om liefde en vriendschap te vinden.",
      "Advies en verhalen voor de vriendschappen die je zoekt.",
      "De hub voor vriendschap",
      "Van Tokio tot Toronto: ontdek hoe de liefde wereldwijd werd gevonden via Bumble.",
      "Echte verhalen",
      "Plan je perfecte date, wanneer, waar of met wie je ook date.",
      "Datinggidsen per seizoen",
      "Verhalen ontdekken",
      "Meer lezen",
      "Bumble op {{social_network}}",
      "Contact",
      "Inloggen",
      "(opens in new window)",
      "Veelgestelde vragen",
      "Cookie Policy",
      "Bumble – Blog",
      "Vacatures",
      "Chatten",
      "Steden",
      "Cookies beheren",
      "Copyright © 2006 – heden. Bumble. Alle rechten voorbehouden.",
      "Rapport Vertrouwen in daten",
      "Apple en het Apple-logo zijn handelsmerken van Apple Inc.{{__EOL__}}Google Play is een handelsmerk van Google LLC.",
      "Downloaden",
      "Facebook",
      "Volg ons",
      "Hulppagina",
      "Instagram",
      "Taal",
      "LinkedIn",
      "Bumble is onderdeel van Bumble Inc.",
      "Privacybeleid",
      "Safety centre",
      "Sitemap",
      "Verklaring inzake moderne slavernij",
      "Algemene voorwaarden",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "dagen"
            ],
            "singular": [
                  "dag"
            ]
      },
      "hour": {
            "plural": [
                  "uur"
            ],
            "singular": [
                  "uur"
            ]
      },
      "minute": {
            "plural": [
                  "minuten"
            ],
            "singular": [
                  "minuut"
            ]
      },
      "month": {
            "plural": [
                  "maanden"
            ],
            "singular": [
                  "maand"
            ]
      },
      "second": {
            "plural": [
                  "seconden"
            ],
            "singular": [
                  "seconde"
            ]
      },
      "year": {
            "plural": [
                  "jaar"
            ],
            "singular": [
                  "jaar"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
